import React from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BrandNav from "../../components/BrandNav";

export default function RoboticsLesson() {
  const { id } = useParams();
  const { t } = useTranslation();
  return (
    <>
      <BrandNav />
      <main className="ftg-page">
        <h1>{t("robotics.lesson_title")} #{id}</h1>
      </main>
    </>
  );
}
